import styled from "styled-components";

export const Container = styled.div`
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  padding: 25px;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const Image = styled.img`
  margin-right: 15px;
`;
